import { useEffect } from "react";

import { IPlaceHistoryService, IPlaceSearchResult } from "../placeSearchTypes";


export interface RecentPlacesListProps {
    placeHistoryService: IPlaceHistoryService;
    onView: (item: IPlaceSearchResult) => void;
}

const useRecentPlacesList = (props: RecentPlacesListProps) => {

    const results = props.placeHistoryService.items;

    useEffect(() => {
        props.placeHistoryService.load();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        results, hasResults: !!results && results.length > 0,
        loadStatus: props.placeHistoryService.loadStatus
    };

};

export default useRecentPlacesList;